/**
 * Builds the Typesense filter for the colours of a product.
 *
 * Colours that are sold out and will not be restocked (ending) are rendered by the
 * server in a data-excluded-option-ids attribute. The colour index itself holds no
 * stock, so they are excluded here instead.
 */
export function productColorFilter(element, productId) {
  const filter = `product_id:=${productId}`
  const ids = parseIds(element.dataset.excludedOptionIds)

  if (ids.length === 0) {
    return filter
  }

  return `${filter} && id:!=[${ids.join(',')}]`
}

function parseIds(value) {
  try {
    const ids = JSON.parse(value ?? '[]')

    return Array.isArray(ids) ? ids.map(Number).filter((id) => Number.isInteger(id) && id > 0) : []
  } catch {
    return []
  }
}
